import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// import { ThemeProvider } from './pms-dashboard/context/ThemeContext';
// import { SidebarProvider } from './pms-dashboard/context/SidebarContext';
// import { TabProvider } from './pms-dashboard/context/TabContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename='/'>
      <>
        {/* <ThemeProvider> */}
          {/* <SidebarProvider> */}
            {/* <TabProvider> */}
              <App />
            {/* </TabProvider> */}
          {/* </SidebarProvider> */}
        {/* </ThemeProvider> */}
      </>
    </BrowserRouter>
  </React.StrictMode>
);
